import {Component, OnInit} from '@angular/core';
import {TranslocoModule} from '@jsverse/transloco';
import {DashboardFiltreTemporelComponent} from './dashboard-filtre-temporel/dashboard-filtre-temporel.component';
import {DashboardNavigationComponent} from './dashboard-navigation/dashboard-navigation.component';
import {FiltreAccueilPeriode} from '../FiltreAccueilPeriode';
import {CarteFacturesTransmisesComponent} from './zone-ventes/carte-factures-transmises/carte-factures-transmises.component';
import {CarteSuiviRegularisationsVenteComponent} from './zone-ventes/carte-suivi-regularisations/carte-suivi-regularisations.component';
import {CarteRepartitionStatutsVenteComponent} from './zone-ventes/carte-repartition-statuts/carte-repartition-statuts.component';
import {CartePodiumMotifsRetoursComponent} from './zone-ventes/carte-podium-motifs-retours/carte-podium-motifs-retours.component';
import {CarteFacturesRecuesComponent} from './zone-achats/carte-factures-recues/carte-factures-recues.component';
import {CarteSuiviRegularisationsAchatComponent} from './zone-achats/carte-suivi-regularisations/carte-suivi-regularisations.component';
import {CarteRepartitionStatutsAchatComponent} from './zone-achats/carte-repartition-statuts/carte-repartition-statuts.component';
import {DonneesZoneDashboard} from './DonneesZoneDashboard';
import {APrHabilitation, PermissionsService} from "../../../../../val-ammon-permissions/val-permissions-lib/src/public-api";

//Identifiant du DICO d'habilitation de la zone Achats du tableau de bord
const DicoStatistiquesAchatsId = "E4DB80B6-886E-42E5-B228-3259C48DF1AD";

//Identifiant du DICO d'habilitation de la zone Ventes du tableau de bord
const DicoStatistiquesVentesId = "A4A6060F-CA3E-4800-985E-498C5BA4330E";

//Composant tableau de bord de la page d'accueil
@Component (
{
	selector: 'val-vue-dashboard',
	imports:
	[
		TranslocoModule,
		DashboardFiltreTemporelComponent,
		DashboardNavigationComponent,
		CarteFacturesTransmisesComponent,
		CarteSuiviRegularisationsVenteComponent,
		CarteRepartitionStatutsVenteComponent,
		CartePodiumMotifsRetoursComponent,
		CarteFacturesRecuesComponent,
		CarteSuiviRegularisationsAchatComponent,
		CarteRepartitionStatutsAchatComponent
	],
	templateUrl: './vue-dashboard.component.html',
	styleUrl: './vue-dashboard.component.scss'
})
export class VueDashboardComponent implements OnInit
{
	//Création
	//  Paramètres
	//    permissionsService : Service de récupération des habilitations
	constructor (private permissionsService: PermissionsService)
	{
		this.filtrePeriodeSelectionne = FiltreAccueilPeriode.TrenteJours;
		this.zoneVentesVisible = false;
		this.zoneAchatsVisible = false;
		this.zonesVisibles = [];
	}

	//Période sélectionnée dans le filtre temporel
	public filtrePeriodeSelectionne: FiltreAccueilPeriode;

	//Indique si la zone Ventes est visible (habilitation sur le DICO "Statistiques Ventes")
	public zoneVentesVisible: boolean;

	//Indique si la zone Achats est visible (habilitation sur le DICO "Statistiques Achats")
	public zoneAchatsVisible: boolean;

	//Zones actuellement visibles, pour la navigation rapide entre zones
	public zonesVisibles: DonneesZoneDashboard[];

	//Initialise le composant
	public async ngOnInit () : Promise<void>
	{
		let valApiResultat;

		try
		{
			valApiResultat = await this.permissionsService.RetournerHabilitations ([DicoStatistiquesAchatsId, DicoStatistiquesVentesId]);

			if (valApiResultat.status === "success")
				this.TraiterHabilitations (valApiResultat.resultat!);
		}
		catch (erreur)
		{
		}
	}

	//Traite le changement de filtre temporel
	//  Paramètres
	//    periode : Nouvelle période sélectionnée
	public OnFiltreChange (periode: FiltreAccueilPeriode) : void
	{
		this.filtrePeriodeSelectionne = periode;
	}

	//Traite les habilitations reçues pour déterminer les zones visibles
	//  Paramètres
	//    habilitations : Habilitations reçues
	private TraiterHabilitations (habilitations: APrHabilitation[]) : void
	{
		let habilitationVentes: APrHabilitation | undefined;
		let habilitationAchats: APrHabilitation | undefined;

		habilitationVentes = habilitations.find (hab => hab.identifiantDico.toUpperCase () === DicoStatistiquesVentesId);
		habilitationAchats = habilitations.find (hab => hab.identifiantDico.toUpperCase () === DicoStatistiquesAchatsId);

		this.zoneVentesVisible = !!habilitationVentes?.modification;
		this.zoneAchatsVisible = !!habilitationAchats?.modification;

		this.zonesVisibles = [];

		if (this.zoneVentesVisible)
			this.zonesVisibles.push ({ id: "zone-ventes", cleTraduction: "dashboard.navigation.ventes" });

		if (this.zoneAchatsVisible)
			this.zonesVisibles.push ({ id: "zone-achats", cleTraduction: "dashboard.navigation.achats" });
	}
}
